import { computed, makeObservable, runInAction } from "mobx";
import { BaseUiStore } from "./base.ui.store";
import { AgtFitnessMultiGpUiStore } from "./agt.fitness.ui.store";
import { KvVdYearMultiGpModel, KvVdYearMultiGpStore } from "../kv.vd.year.multigp.store";
import { AgtSocialMediaUiStore } from "./agt.socialmedia.ui.store";
import { AgtUserUiStore } from "./agt.user.ui.store";
import { AgtGoogleProfileUiStore } from "./agt.googleprofile.ui.store";
import { Steart } from "app/models/core/steart.model";


const VDDef2025 = [
    { vd: 'M', base: 898, },
    { vd: 'H', base: 939, },
    { vd: 'K', base: 1063, },
    { vd: 'B', base: 1018, },
    { vd: 'S', base: 1158, },
    { vd: 'F', base: 846, },
    { vd: 'N', base: 593, },
    { vd: 'L', base: 1068, },
];

// 2026 
const VDDef = [
    { vd: 'H', base: 939, },
    { vd: 'K', base: 1066, },
    { vd: 'B', base: 1024, },
    { vd: 'L', base: 1099, },
    { vd: 'F', base: 847, },
    { vd: 'S', base: 1159, },
    { vd: 'M', base: 898, },
    { vd: 'N', base: 595, },
];



export class MultiGpVM {
    year: number;
    vd: String;

    constructor(year: number, vd: string) {
        this.year = year;
        this.vd = vd;
    }
    // Gup
    gupMin25Count: number = 0;
    gupMin25Base: number = 0;
    gupMonthlyCounts: Map<number, number> = new Map();

    setGupGP(gupMin25Count: number, base: number, gupMonthlyCounts: Map<number, number>) {
        this.gupMin25Count = gupMin25Count;
        this.gupMin25Base = base;
        this.gupMonthlyCounts = gupMonthlyCounts;
    }
    @computed
    get gupThreshold1() {
        return Math.floor(this.gupMin25Base * 0.10);
    }
    @computed
    get gupThreshold2() {
        return Math.floor(this.gupMin25Base * 0.15);
    }
    @computed
    get gupMonthsPassing1() {
        let count = 0;
        this.gupMonthlyCounts.forEach((c) => {
            if (c >= this.gupThreshold1) count++;
        });
        return count;
    }

    @computed
    get gupMonthsPassing2() {
        let count = 0;
        this.gupMonthlyCounts.forEach((c) => {
            if (c >= this.gupThreshold2) count++;
        });
        return count;
    }

    // SM (Facebook & Insta) - 2026: Sichtkontakte >= 30k
    smErgebnis: number = 0;
    smBase: number = 0;
    setSmGP(smErgebnis: number, smBase: number) {
        this.smErgebnis = smErgebnis;
        this.smBase = smBase;
    }

    @computed
    get smZiel1() {
        return Math.floor(this.smBase * 0.10);
    }

    @computed
    get smZiel2() {
        return Math.floor(this.smBase * 0.15);
    }

    // AKUMA 
    akumaCount: number = 0;
    akumaBase: number = 0;
    isCurrentAkumaPrimeUserGpCount: number = 0;
    akumaPlanerGpCount: number = 0;
    akumaPlanerGpCountDebug: number = 0;
    setAkumaGp(akumaCount: number, akumaBase: number, primeUserCount: number = 0, akumaPlanerGpCount: number = 0, akumaPlanerGpCountDebug: number = 0) {
        this.akumaCount = akumaCount;
        this.akumaBase = akumaBase;
        this.isCurrentAkumaPrimeUserGpCount = primeUserCount;
        this.akumaPlanerGpCount = akumaPlanerGpCount;
        this.akumaPlanerGpCountDebug = akumaPlanerGpCountDebug;
    }

    @computed
    get akumaZiel() {
        return Math.floor(this.akumaBase * 0.25);
    }

    // LEADNOW
    leadnowCount: number = 0
    leadnowAgtOnlyCount: number = 0;
    leadnowBase: number = 0;
    setLeadNowGp(leadnowCount: number, leadnowAgtOnlyCount: number, leadnowBase: number) {
        this.leadnowCount = leadnowCount;
        this.leadnowAgtOnlyCount = leadnowAgtOnlyCount;
        this.leadnowBase = leadnowBase;
    }

    @computed
    get leadnowZiel1() {
        return Math.floor(this.leadnowBase * 0.15);
    }

    @computed
    get leadnowZiel2() {
        return Math.floor(this.leadnowBase * 0.20);
    }
}





export class AgtMultiGpUiStore extends BaseUiStore<MultiGpVM> {
    name = 'AgtMultiGpUiStore';
    agtFitnessMultiGpUiStore: AgtFitnessMultiGpUiStore;
    kvVdYearMultiGpStore: KvVdYearMultiGpStore;
    agtSocialMediaUiStore: AgtSocialMediaUiStore;
    agtUserUiStore: AgtUserUiStore;
    agtGoogleProfileUiStore: AgtGoogleProfileUiStore;

    constructor(agtFitnessUiStore: AgtFitnessMultiGpUiStore,
        kvVdYearMultiGpStore: KvVdYearMultiGpStore,
        agtSocialMediaUiStore: AgtSocialMediaUiStore,
        agtUserUiStore: AgtUserUiStore,
        agtGoogleProfileUiStore: AgtGoogleProfileUiStore) {
        super();
        makeObservable(this);
        this.agtFitnessMultiGpUiStore = agtFitnessUiStore;
        this.kvVdYearMultiGpStore = kvVdYearMultiGpStore;
        this.agtSocialMediaUiStore = agtSocialMediaUiStore;
        this.agtUserUiStore = agtUserUiStore;
        this.agtGoogleProfileUiStore = agtGoogleProfileUiStore;
    }


    get fitnessItems() {
        return this.agtFitnessMultiGpUiStore.items;
    }

    async _baseLoad() {
        if (this.items.length > 0) {
            return;
        }

        await Promise.all([this.agtFitnessMultiGpUiStore.load(), this.agtSocialMediaUiStore.load(), this.agtUserUiStore.load(), this.agtGoogleProfileUiStore.load()]);
        const gupItems = await this.agtGoogleProfileUiStore.loadMultiGp26();
        const year = new Date().getFullYear();
        const smItems = await this.agtSocialMediaUiStore.loadYtd();

        const res: MultiGpVM[] = [];

        const users = this.agtUserUiStore.items;

        for (const vd of VDDef) {
            const multiGp = new MultiGpVM(year, vd.vd);
            res.push(multiGp);

            const user = users.find(u => u.firstVd === vd.vd && u.steart.steart === Steart.LDP && u.lebend);
            if (!user) {
                continue;
            }

            const fits = this.agtFitnessMultiGpUiStore.items.filter((a) => a.agt.LDP && a.agt.LDP.bnrId === user.bnrId);
            console.log('fits for vd', vd.vd, fits.length, user.name);
            /// GUP ///
            const vdGupItems = gupItems.filter((g) => g.agt.LDP && g.agt.LDP.bnrId === user.bnrId);
            let gupSum = 0;
            const gupMonthlyCounts = new Map<number, number>();
            vdGupItems.forEach(g => {
                gupSum += g.gpCount;
                for (const bm of g.neueBewGreater3Bms) {
                    gupMonthlyCounts.set(bm, (gupMonthlyCounts.get(bm) || 0) + 1);
                }
            });
            multiGp.setGupGP(gupSum, vd.base, gupMonthlyCounts);

            //// SM //// 2026: Sichtkontakte >= 30k
            let sms = smItems.filter((a) => a.agt.LDP && a.agt.LDP.bnrId === user.bnrId);
            let smSum = 0;
            sms.forEach(sm => {
                smSum += sm.hasMoreThan30kViewsMultiGp26GpCount;
            });
            multiGp.setSmGP(smSum, vd.base);

            /// AKUMA
            const akumas = fits.filter(x => x.akumaMultiGpCount >= 1);
            let akumaSum = 0;
            let primeUserCount = 0;
            let akumaPlanerGpCount = 0;
            let akumaPlanerGpCountDebug = 0;
            akumas.forEach(sm => {
                akumaSum += sm.akumaMultiGpCount;
                primeUserCount += sm.isCurrentAkumaPrimeUserGpCount;
                akumaPlanerGpCount += sm.akumaPlanerGpCount;
                akumaPlanerGpCountDebug += sm.akumaPlanerGpCountDebug;
            });
            multiGp.setAkumaGp(akumaSum, vd.base, primeUserCount, akumaPlanerGpCount, akumaPlanerGpCountDebug);

            /// LEAD.NOW
            const leadnows = fits.filter(x => x.leadNow!);
            let leadnowSum = 0;
            let leadnowAgtOnlySum = 0;
            leadnows.forEach(sm => {
                leadnowSum += sm.leadnowMultiGpCount;
                leadnowAgtOnlySum += sm.leadnowMultiGpAgtOnlyCount;
            });
            multiGp.setLeadNowGp(leadnowSum, leadnowAgtOnlySum, vd.base);

        }
        runInAction(() => {
            this.items = res;
        })

    }

    gpSaveYear = 2026;

    async saveGup() {
        let kvs = await this.kvVdYearMultiGpStore.findAll();
        kvs = kvs.filter(x => x.group === 'multigp' && x.bm === this.gpSaveYear);
        for (const a of this.items) {
            let model = kvs.find(x => x.group === 'multigp' && x.key === a.vd && x.bm === a.year && x.key2 === 'gup1');


            if (!model) {
                model = new KvVdYearMultiGpModel({ group: 'multigp', key: a.vd, bm: a.year, key2: 'gup1' });
            }
            model.valueJson = JSON.stringify({ ergebnis: a.gupMonthsPassing1, ziel: 8, posId: 10010 });
            await this.kvVdYearMultiGpStore.save(model);


            model = kvs.find(x => x.group === 'multigp' && x.key === a.vd && x.bm === a.year && x.key2 === 'gup2');
            if (!model) {
                model = new KvVdYearMultiGpModel({ group: 'multigp', key: a.vd, bm: a.year, key2: 'gup2' });
            }
            model.valueJson = JSON.stringify({
                ergebnis: a.gupMonthsPassing2, ziel: 8, posId: 10011
            });
            await this.kvVdYearMultiGpStore.save(model);
            await this.kvVdYearMultiGpStore.copyToPosBnr();
        }
    }

    async saveSm() {
        let kvs = await this.kvVdYearMultiGpStore.findAll();
        kvs = kvs.filter(x => x.group === 'multigp' && x.bm === this.gpSaveYear);
        for (const a of this.items) {
            let model = kvs.find(x => x.group === 'multigp' && x.key === a.vd && x.bm === a.year && x.key2 === 'sm1');


            if (!model) {
                model = new KvVdYearMultiGpModel({ group: 'multigp', key: a.vd, bm: a.year, key2: 'sm1' });
            }
            model.valueJson = JSON.stringify({ ergebnis: a.smErgebnis, ziel: a.smZiel1, posId: 10020 });
            await this.kvVdYearMultiGpStore.save(model);


            model = kvs.find(x => x.group === 'multigp' && x.key === a.vd && x.bm === a.year && x.key2 === 'sm2');
            if (!model) {
                model = new KvVdYearMultiGpModel({ group: 'multigp', key: a.vd, bm: a.year, key2: 'sm2' });
            }
            model.valueJson = JSON.stringify({
                ergebnis: a.smErgebnis, ziel: a.smZiel2, posId: 10021
            });
            await this.kvVdYearMultiGpStore.save(model);
            await this.kvVdYearMultiGpStore.copyToPosBnr();
        }
    }


    async saveAkuma() {
        let kvs = await this.kvVdYearMultiGpStore.findAll();
        kvs = kvs.filter(x => x.group === 'multigp' && x.bm === this.gpSaveYear);
        for (const a of this.items) {
            let model = kvs.find(x => x.group === 'multigp' && x.key === a.vd && x.bm === a.year && x.key2 === 'akuma');


            if (!model) {
                model = new KvVdYearMultiGpModel({ group: 'multigp', key: a.vd, bm: a.year, key2: 'akuma' });
            }
            model.valueJson = JSON.stringify({ ergebnis: a.akumaCount, ziel: a.akumaZiel, posId: 10030 });
            await this.kvVdYearMultiGpStore.save(model);
            await this.kvVdYearMultiGpStore.copyToPosBnr();
        }
    }

    async saveLeadNow() {
        let kvs = await this.kvVdYearMultiGpStore.findAll();
        kvs = kvs.filter(x => x.group === 'multigp' && x.bm === this.gpSaveYear);
        for (const a of this.items) {
            let model = kvs.find(x => x.group === 'multigp' && x.key === a.vd && x.bm === a.year && x.key2 === 'leadnow1');


            if (!model) {
                model = new KvVdYearMultiGpModel({ group: 'multigp', key: a.vd, bm: a.year, key2: 'leadnow1' });
            }
            model.valueJson = JSON.stringify({ ergebnis: a.leadnowCount, ziel: a.leadnowZiel1, posId: 10040 });
            await this.kvVdYearMultiGpStore.save(model);

            model = kvs.find(x => x.group === 'multigp' && x.key === a.vd && x.bm === a.year && x.key2 === 'leadnow2');
            if (!model) {
                model = new KvVdYearMultiGpModel({ group: 'multigp', key: a.vd, bm: a.year, key2: 'leadnow2' });
            }
            model.valueJson = JSON.stringify({ ergebnis: a.leadnowCount, ziel: a.leadnowZiel2, posId: 10041 });
            await this.kvVdYearMultiGpStore.save(model);
            await this.kvVdYearMultiGpStore.copyToPosBnr();
        }
    }


}